import {
  Box,
  Chip,
  DeleteIcon,
  EditOutlinedIcon,
  IconButton,
  Stack,
  Typography,
} from '@cmg/design-system';
import { FormattedTime } from '@cmg/i18n';
import capitalize from 'lodash/capitalize';
import React from 'react';

import { OfferingNotes_OfferingNotePartsFragment } from './graphql';

type Props = {
  note: OfferingNotes_OfferingNotePartsFragment;
  handleDeleteOfferingNote: (noteId: string) => void;
  handleEditOfferingNote: (noteId: string) => void;
};

const OfferingNote: React.FC<Props> = ({
  note,
  handleDeleteOfferingNote,
  handleEditOfferingNote,
}) => {
  const onDeleteOfferingNote = () => {
    handleDeleteOfferingNote(note.id);
  };

  const onEditOfferingNote = () => {
    handleEditOfferingNote(note.id);
  };

  return (
    <Box mb={1} pl={1} data-testid="offering-notes-list">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Chip size="medium" aria-label="Note topic" label={capitalize(note.subject)} />
        <Box>
          <IconButton aria-label="Edit note" onClick={onEditOfferingNote}>
            <EditOutlinedIcon fontSize="small" color="action" />
          </IconButton>
          <IconButton aria-label="Delete note" onClick={onDeleteOfferingNote}>
            <DeleteIcon fontSize="small" color="action" />
          </IconButton>
        </Box>
      </Stack>

      <Box mt={0.5}>
        <Typography variant="body1" aria-label="Note field">
          {note.note}
        </Typography>
      </Box>
      <Stack direction="row" mt={0.5} gap={1} aria-label="Last updated field">
        <Typography variant="body1" color="text.secondary">
          Last Updated:
        </Typography>
        <Typography variant="body1">
          {note.lastEditedBy} <FormattedTime value={note.lastEditedAt} format="dateTime" />
        </Typography>
      </Stack>
    </Box>
  );
};

export default OfferingNote;
